import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-user',
  imports: [SharedModule],
  templateUrl: './create-user.component.html',
  styleUrl: './create-user.component.scss'
})
export class CreateUserComponent {
  @Input() type: 'Add' | 'Update' = 'Add';
  @Input() initialData: any; // For editing existing user
  @Input() isLoading: boolean = false;
  @Output() reload = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<void>();

  @Input() userDataToEdit: any = null; // To hold the user data to be edited

  @Input() orgId: string = ''; // Organization ID passed from the parent component
  @Input() campuses: any[] = []; // List of campuses passed to the component
  @Input() departments: any[] = []; // List of departments passed to the component
  @Input() roles: any[] = []; // List of roles passed to the component

  userForm!: FormGroup;
  submitted = false;

  genderOptions = ['Male', 'Female', 'Other'];

  // Replace these with your actual fetched data from service
  departmentOptions: any[] = [];

  roleOptions: any[] = [];

  statusOptions = ['Active', 'Inactive'];

  campusOptions: any[] = [];

  twoFAOptions = [
    { label: 'Enabled', value: true },
    { label: 'Disabled', value: false },
  ];

  constructor(private fb: FormBuilder,
    private orgService: OrganizationService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.userForm = this.fb.group({
      organization_id: [this.orgId], // Organization ID
      fname: ['', Validators.required],
      lname: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      gender: ['', Validators.required],
      prefix: [''],
      dept_id: [null, Validators.required],
      role_id: [null, Validators.required],
      status: ['', Validators.required],
      campus_id: [null, Validators.required],
      twoFactorAuthentication: [false],
      details: ['']
    });

    this.departmentOptions = this.departments?.map((department: any) => {
      return { label: department.name, value: department.dept_id };
    }
    );
    this.campusOptions = this.campuses?.map((campus: any) => {
      return { label: campus.name, value: campus.campus_id };
    });

    this.roleOptions = this.roles?.map((role: any) => {
      return { label: role.name, value: role.role_id };
    });

    console.log(this.roleOptions);
    console.log(this.departmentOptions);
    console.log(this.campusOptions);

    console.log(this.departments);
    console.log(this.campuses);
    console.log(this.roles);

    if (this.type === 'Update' && this.userDataToEdit) {
      this.userForm.patchValue(this.userDataToEdit);
      // remove password field from the form if editing
      this.userForm.removeControl('password');
    }
  }

  submitForm(): void {
    this.submitted = true;

    if (this.userForm.invalid) return;

    const payload = this.userForm.value;

    this.isLoading = true; // Set loading state to true

    if (this.type === 'Update') {
      payload.user_id = this.userDataToEdit.user_id; // Add user ID for update
      this.orgService.updateUser(payload).subscribe({
        next: (response) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User created successfully!' });
          this.reload.emit(); // Emit reload event to parent component
          this.handleCloseDialog(); // Close the modal after successful submission
        },
        error: (error) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create user!' });
        }
      }
      );
    } else {
      this.orgService.createUser(payload).subscribe({
        next: (response) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User created successfully!' });
          this.reload.emit(); // Emit reload event to parent component
          this.handleCloseDialog(); // Close the modal after successful submission
        },
        error: (error) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create user!' });
        }
      }
      );
    }
  }

  handleCloseDialog(): void {
    this.closeModal.emit();
  }
}
